export default __webpack_public_path__ + "5dcc2511f4c9eeb765245abcbdc170f4.svg";